var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 23C14.8577 23 17.4609 21.9103 19.4166 20.1237L11.6066 12.3137L4.1821 19.7382C6.17577 21.7523 8.94218 23 12 23ZM3.51062 18.9955L10.8995 11.6066L3.87627 4.58336C2.08971 6.53914 1 9.14231 1 12C1 14.6572 1.94215 17.0943 3.51062 18.9955ZM11.6066 10.8995L4.58338 3.87625C6.53916 2.08971 9.14232 1 12 1C14.6572 1 17.0943 1.94215 18.9955 3.51062L11.6066 10.8995ZM12.3137 11.6066L19.7382 4.1821C21.7523 6.17577 23 8.94218 23 12C23 14.8577 21.9103 17.4608 20.1237 19.4166L12.3137 11.6066Z",
    fill: "#006EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePlaceholder);
export default __webpack_public_path__ + "static/media/device-placeholder.52c78bf43520102e7baa7769eb3092b2.svg";
export { ForwardRef as ReactComponent };